import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import API from "../helpers/api";
import AddIcon from "../UIComponents/AddIcon";
import { putClientUserDetails, getClientUserDetails, getClientManagementList } from "../Actions/ClientManagementAPI";
import "react-datepicker/dist/react-datepicker.css";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/style.css";

let searchData = {
  Name: '',
  PageNumber: 1,
  PageSize: 20
}
let currentUser = JSON.parse(localStorage.getItem("currentUser"));

class ClientManagementEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ClientInfo: {
        clientId: 0,
        companyName: "",
        telephone: "",
        address: "",
        mail: "",
        isDeleted: false,
        modifiedBy: "",
        logoName: "",
        logo: "",
      },
      PhotoFile: "",
      FleetManager: [],
      TechSuperintendent: [],
      TechExecutive: [],
      OwnerLogo: [],
      isEmailNotificationEnabled: false,
      level2ToEmails: [],
      level2CcEmails: [],
      monthlyToEmails: [],
      monthlyCcEmails: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateData = this.UpdateData.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getClientUserDetails(id));
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, fleetManagerList, techExecutiveList, techSuperintendentList, ClientDetails, ClientUsersDetails } = nextProps;

    if (fleetManagerList) {
      prevState.FleetManager = fleetManagerList;
    }
    if (techSuperintendentList) {
      prevState.TechSuperintendent = techSuperintendentList;
    }
    if (techExecutiveList) {
      prevState.TechExecutive = techExecutiveList;
    }
    if (ClientDetails && ClientDetails !== "") {
      prevState.ClientInfo.clientId = ClientDetails.shippingCompanyId;
      prevState.ClientInfo.companyName = ClientDetails.name;
      prevState.ClientInfo.address = ClientDetails.address;
      prevState.ClientInfo.telephone = ClientDetails.phone;
      prevState.ClientInfo.mail = ClientDetails.mail;
      prevState.PhotoFile = ClientDetails.logo;
      prevState.ClientInfo.logo = ClientDetails.logo;
      prevState.isEmailNotificationEnabled =
        !!ClientDetails.mailAlertForLevel2AndMonthlyReport;
      prevState.level2ToEmails = Array.isArray(ClientDetails.level2ToMailForAlert)
        ? ClientDetails.level2ToMailForAlert
        : ClientDetails.level2ToMailForAlert
          ? ClientDetails.level2ToMailForAlert.split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "")
          : [];
      prevState.level2CcEmails = Array.isArray(ClientDetails.level2CcMailForAlert)
        ? ClientDetails.level2CcMailForAlert
        : ClientDetails.level2CcMailForAlert
          ? ClientDetails.level2CcMailForAlert.split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "")
          : [];
      prevState.monthlyToEmails = Array.isArray(ClientDetails.monthlyReportToMailForAlert)
        ? ClientDetails.monthlyReportToMailForAlert
        : ClientDetails.monthlyReportToMailForAlert
          ? ClientDetails.monthlyReportToMailForAlert.split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "")
          : [];
      prevState.monthlyCcEmails = Array.isArray(ClientDetails.monthlyReportCcMailForAlert)
        ? ClientDetails.monthlyReportCcMailForAlert
        : ClientDetails.monthlyReportCcMailForAlert
          ? ClientDetails.monthlyReportCcMailForAlert.split(",")
              .map((item) => item.trim())
              .filter((item) => item !== "")
          : [];
      dispatch({ type: "ClientDetails", data: "" });
    }
  }

  // UpdateData() {
  //   const { dispatch } = this.props;
  //   dispatch(putClientManagementDetails(this.state.ClientInfo));
  //   this.props.history.push("/Home/Management/Client");
  // }

  UpdateData() {
    const { dispatch } = this.props;
    const { FleetManager, TechSuperintendent, TechExecutive } = this.state;
    let Userlist = [...FleetManager, ...TechSuperintendent, ...TechExecutive];
    let emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (this.state.ClientInfo.mail !== '') {
      if (emailregex.test(this.state.ClientInfo.mail)) {
        if (this.state.PhotoFile !== "") {
          let url = `${API.PutShippingCompany}`;
          const clientPayload = {
            ...this.state.ClientInfo,
            mailAlertForLevel2AndMonthlyReport:
              this.state.isEmailNotificationEnabled,
            level2ToMailForAlert: this.state.level2ToEmails.toString(),
            level2CcMailForAlert: this.state.level2CcEmails.toString(),
            monthlyReportToMailForAlert: this.state.monthlyToEmails.toString(),
            monthlyReportCcMailForAlert: this.state.monthlyCcEmails.toString(),
          };
          axios.put(url, clientPayload, {
            headers: {
              key: currentUser.accessToken
            }
          })
            .then((response) => {
              // let user1 = this.state.fleetmanager.map(u1 => {
              //   let fleet = {
              //     clientId: this.state.ClientInfo.shippingCompanyId,
              //     clientUsers: [
              //       {
              //         clinetUserId: u1.shippingCompanyUserId,
              //         role: "fleetmanager",
              //         name: u1.name,
              //         address: u1.address,
              //         picContactDetails: u1.picContactDetails,
              //       }
              //     ],
              //     modifiedBy: u1.modifiedBy,
              //     isDeleted: false
              //   };
              //   return fleet;
              // })
              // let user2 = this.state.superintendent.map(u2 => {
              //   let techsuperintendent = {
              //     clientId: this.state.ClientInfo.shippingCompanyId,
              //     clientUsers: [
              //       {
              //         clinetUserId: u2.shippingCompanyUserId,
              //         role: "superintendent",
              //         name: u2.name,
              //         address: u2.address,
              //         picContactDetails: u2.picContactDetails,
              //       }
              //     ],
              //     modifiedBy: u2.modifiedBy,
              //     isDeleted: false
              //   };
              //   return techsuperintendent;
              // })
              // let user3 = this.state.executive.map(u3 => {
              //   let techexecutive = {
              //     clientId: this.state.ClientInfo.shippingCompanyId,
              //     clientUsers: [
              //       {
              //         clinetUserId: u3.shippingCompanyUserId,
              //         role: "technicalexecutive",
              //         name: u3.name,
              //         address: u3.address,
              //         picContactDetails: u3.picContactDetails,
              //       }
              //     ],
              //     modifiedBy: u3.modifiedBy,
              //     isDeleted: false

              //   };
              //   return techexecutive;
              // })
              // let userArray = [...user1, ...user2, ...user3];
              dispatch(putClientUserDetails(Userlist));
              toast.success('Updated Successfully', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              dispatch(getClientManagementList(searchData));
              this.moveClientList();
              dispatch({
                type: "postClientDetailsSuccess",
                data: response.data,
              })
            })
            .catch((error) => {
              swal("Error!", "Something went wrong. Please try again.", "warning");
              dispatch({
                type: "postClientDetailsFailure",
                error: "ERROR"
              })
            })
        } else {
          swal("Error!", "Logo is mandatory", "warning");
        }
      }
      else {
        swal('Error!', 'Invalid email format', 'warning');
      }
    }
    else {
      swal('Error!', 'Email is mandatory', 'warning');
    }
  }

  // handleInputChange(e) {
  //   let nodeName = e.target.name;
  //   this.state.ClientInfo[nodeName] = e.target.value;
  //   this.setState({});
  // }
  handleInputChange(e) {
    let nodeName = e.target.name;
    const regex = /^\d*$/;
    if (nodeName == 'telephone') {
      if (regex.test(e.target.value)) {
        this.state.ClientInfo[nodeName] = e.target.value;
      }
    }
    else {
      this.state.ClientInfo[nodeName] = e.target.value;
    }

    this.setState({});
  }

  handleEmailNotificationToggle = (e) => {
    this.setState({
      isEmailNotificationEnabled: e.target.checked,
    });
  };

  handleInputFileChange(event) {
    let _this = this;
    let file = event?.target?.files[0];
    let filename = event?.target?.files[0].name;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let FileUrl = reader?.result;
      let finalResult = reader?.result.split(",");
      _this.state.PhotoFile = reader?.result;
      _this.state.ClientInfo["logo"] = finalResult[1];
      _this.state.ClientInfo["logoName"] = filename;
      _this.setState({});
    };
  }

  OpenPopup() {
    confirmAlert({
      message: "Are you sure want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {

            this.state.ClientInfo.logoName = "";
            this.state.ClientInfo.logo = "";
            this.state.PhotoFile = "";
            this.setState({});
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  }


  ClearInput = () => {
    this.state.ClientInfo.logoName = "";
    this.state.ClientInfo.logo = "";
    this.state.PhotoFile = "";
    this.setState({});
  };
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { showSidePane } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row px-3 pb-3">
            <button
              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
              onClick={() => this.BacktoPrevious()}
            >
              <div style={{ position: 'relative' }}>
                <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
              </div>
            </button>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="panel-box">
                <div className="row ">
                  <div className="col-lg-12">
                    <div className="card  MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-1 pl-3 mt-2" style={{ color: "092a51" }}>Basic Information</h5>
                      </div>
                    </div>
                    <div className="row search-filter-box pb-4">
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Name</label>
                        <input
                          className="form-control"
                          type="text"
                          name="companyName"
                          placeholder="Name"
                          onChange={e => this.handleInputChange(e)}
                          value={this.state.ClientInfo.companyName}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Email<span className="mandatory">*</span></label>
                        <input
                          className="form-control"
                          type="text"
                          name="mail"
                          placeholder="Email"
                          onChange={e => this.handleInputChange(e)}
                          value={this.state.ClientInfo.mail}
                        // readOnly
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Phone</label>
                        <input
                          className="form-control"
                          type="text"
                          name="telephone"
                          placeholder="Phone"
                          onChange={e => this.handleInputChange(e)}
                          value={this.state.ClientInfo.telephone}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">Address</label>
                        <textarea
                          className="form-control"
                          style={{ minHeight: 40, maxHeight: 200 }}
                          name="address"
                          placeholder="Address"
                          onChange={e => this.handleInputChange(e)}
                          value={this.state.ClientInfo.address}
                        ></textarea>
                      </div>
                      <div className={showSidePane ? "col-lg-6" : "col-lg-4"}>
                        <label className="form-label">Logo<span className="mandatory">*</span></label>
                        <br></br>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              Browse File
                              <input
                                type="file"
                                id="files"
                                title=" "
                                accept=".png,.jpg"
                                style={{ marginRight: 40 }}
                                onChange={(e) => this.handleInputFileChange(e)}
                                onClick={(event) => {
                                  event.currentTarget.value = null;
                                }}
                              />
                            </span>
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            placeholder=""
                            name="username"
                            value={this.state.ClientInfo.logoName}
                          />
                          {this.state.ClientInfo.logoName ? (
                            <div
                              class="input-group-append"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="input-group-text">
                                <i
                                  class="fa fa-times"
                                  aria-hidden="true"
                                  onClick={() => this.ClearInput()}
                                ></i>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div
                        className={
                          showSidePane
                            ? "col-12 col-sm-12  col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center"
                            : "col-12 col-sm-12  col-md-4 col-lg-4 col-xl-4 pt-2 align-items-center"
                        }
                      >
                        {this.state.PhotoFile &&
                          this.state.PhotoFile ?
                          <>
                            <div className="row align-items-center">
                              <div
                                className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center"
                                style={{ display: "flex", marginTop: "35px" }}
                              >
                                <div className="ml-2">
                                  <img
                                    src={this.state.PhotoFile}
                                    className="cursorPointer"

                                    style={{
                                      width: "55px",
                                      height: "42px",
                                      marginTop: "-9px",
                                    }}
                                  />
                                </div>
                                <div
                                  className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4 pr-0"
                                  style={{ fontSize: "10px", marginTop: "-15px" }}
                                >
                                  <div className="pl-2 overflow cursorPointer"
                                  >
                                    {this.state.ClientInfo.logoName !== "" ? this.state.ClientInfo.logoName : "logo"}

                                  </div>
                                </div>
                                <div
                                  className=""
                                  style={{ marginTop: "-16px" }}
                                >
                                  <i
                                    className="fa fa-trash click m-1"
                                    onClick={() => {
                                      this.OpenPopup();
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          </>
                          : ""
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row  pb-0">
                  <div className="col-lg-12">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-1 pl-3 mt-2" style={{ color: "092a51" }}>Marine Managers</h5>
                        <div className="m-1 flex" onClick={() => this.showFleetManagersSidePane()}>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box mt-2 pb-0">
                      {this.renderfleetManagerCard()}
                    </div>
                  </div>
                </div>
                <div className="row pb-0">
                  <div className="col-lg-12">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-1 pl-3 mt-2" style={{ color: "092a51" }}>Marine Superintendent </h5>
                        <div className="m-1 flex" onClick={() => this.showTechSuperintendentsSidePane()}>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box mt-2 pb-0">
                      {this.rendertechSuperintendentCard()}
                    </div>
                  </div>
                </div>
                <div className="row pb-0">
                  <div className="col-lg-12">
                    <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                      <div className="flex card-body" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                        <h5 className="card-title ml-1 pl-3 mt-2" style={{ color: "092a51" }}>DPA </h5>
                        <div className="m-1 flex" onClick={() => this.showTechExecutiveSidePane()}>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box mt-2 pb-1">
                      {this.rendertechExecutiveCard()}
                    </div>
                  </div>
                </div>
                <div className="row pb-0">
                  <div className="col-lg-12">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="flex card-body"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-1 pl-3 mt-2"
                          style={{ color: "092a51" }}
                        >
                          Email Notification
                        </h5>
                      </div>
                    </div>
                    <div className="search-filter-box mt-2 pb-3">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="d-flex align-items-center ">
                            <input
                              style={{ height: "20px", width: "20px" }}
                              type="checkbox"
                              name="notificationToggle"
                              id="notificationToggle"
                              className="mr-2"
                              checked={this.state.isEmailNotificationEnabled}
                              onChange={this.handleEmailNotificationToggle}
                            ></input>
                            <label
                              htmlFor="notificationToggle"
                              className="form-label "
                            >
                              Sent level 2 and monthly report notification
                            </label>
                          </div>
                        </div>
                      </div>
                      {this.state.isEmailNotificationEnabled ? (
                        <>
                          <div className="row pt-3">
                            <div className="col-lg-12">
                              <label className="form-label mb-0">
                                Level 2 escalation email
                              </label>
                            </div>
                          </div>
                          <div className="row pt-2">
                            <div className="col-lg-5">
                              <label className="form-label">To Email</label>
                              <ReactMultiEmail
                                className="level2ToEmails"
                                emails={this.state.level2ToEmails}
                                onChange={(_emails) => {
                                  this.setState({ level2ToEmails: _emails });
                                }}
                                getLabel={(email, index, removeEmail) => {
                                  return (
                                    <label
                                      className="m-1"
                                      key={index}
                                      style={{
                                        backgroundColor: "lightgray",
                                        fontSize: "14px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {email}
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          verticalAlign: "middle",
                                          marginLeft: ".25rem",
                                        }}
                                        data-tag-handle
                                        name="delete"
                                        onClick={() => removeEmail(index)}
                                      >
                                        &times;
                                      </span>
                                    </label>
                                  );
                                }}
                              />
                            </div>
                            <div className="col-lg-5">
                              <label className="form-label">Cc Email</label>
                              <ReactMultiEmail
                                className="level2CcEmails"
                                emails={this.state.level2CcEmails}
                                onChange={(_emails) => {
                                  this.setState({ level2CcEmails: _emails });
                                }}
                                getLabel={(email, index, removeEmail) => {
                                  return (
                                    <label
                                      className="m-1"
                                      key={index}
                                      style={{
                                        backgroundColor: "lightgray",
                                        fontSize: "14px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {email}
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          verticalAlign: "middle",
                                          marginLeft: ".25rem",
                                        }}
                                        data-tag-handle
                                        name="delete"
                                        onClick={() => removeEmail(index)}
                                      >
                                        &times;
                                      </span>
                                    </label>
                                  );
                                }}
                              />
                            </div>
                          </div>
                          <div className="row pt-3">
                            <div className="col-lg-12">
                              <label className="form-label mb-0">
                                Monthly report email
                              </label>
                            </div>
                          </div>
                          <div className="row pt-2">
                            <div className="col-lg-5">
                              <label className="form-label">To Email</label>
                              <ReactMultiEmail
                                className="monthlyToEmails"
                                emails={this.state.monthlyToEmails}
                                onChange={(_emails) => {
                                  this.setState({ monthlyToEmails: _emails });
                                }}
                                getLabel={(email, index, removeEmail) => {
                                  return (
                                    <label
                                      className="m-1"
                                      key={index}
                                      style={{
                                        backgroundColor: "lightgray",
                                        fontSize: "14px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {email}
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          verticalAlign: "middle",
                                          marginLeft: ".25rem",
                                        }}
                                        data-tag-handle
                                        name="delete"
                                        onClick={() => removeEmail(index)}
                                      >
                                        &times;
                                      </span>
                                    </label>
                                  );
                                }}
                              />
                            </div>
                            <div className="col-lg-5">
                              <label className="form-label">Cc Email</label>
                              <ReactMultiEmail
                                className="monthlyCcEmails"
                                emails={this.state.monthlyCcEmails}
                                onChange={(_emails) => {
                                  this.setState({ monthlyCcEmails: _emails });
                                }}
                                getLabel={(email, index, removeEmail) => {
                                  return (
                                    <label
                                      className="m-1"
                                      key={index}
                                      style={{
                                        backgroundColor: "lightgray",
                                        fontSize: "14px",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {email}
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          verticalAlign: "middle",
                                          marginLeft: ".25rem",
                                        }}
                                        data-tag-handle
                                        name="delete"
                                        onClick={() => removeEmail(index)}
                                      >
                                        &times;
                                      </span>
                                    </label>
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row search-filter-box pt-1">
                  <div className="col-lg-12 ">
                    <div className="py-2 search-btn-col" style={{ textAlign: "end" }}>
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                        type="submit" onClick={() => this.UpdateData()}>Update
                      </button>
                      <button
                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                        type="button" onClick={() => this.moveClientList()}> {" "} Cancel{" "}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
        </div >
      </div>
    );
  }
  renderfleetManagerCard = () => {
    const { showSidePane, ClientUsersDetails } = this.props;
    const { FleetManager } = this.state;
    return (
      <>
        {FleetManager && FleetManager.length ? FleetManager.map(item => (
          <div className="card click mb-2" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.userName}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.telephone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-1 col-2 m-auto">
                    <div className="text-center">
                      <i className="fa fa-edit fa-lg fa-2x" onClick={() => this.EditUsers(1, item)}></i>
                      <i className="fa fa-trash m-1 fa-2x" onClick={() => this.DeleteUser(item)}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
          :
          <div className="card mb-2" style={{ overflow: "hidden", position: "relative" }}>
            <div class="container">
              <h6 className="resource-list-title no-item-card mb-0">
                No Users
              </h6>
            </div>
          </div>
        }
      </>
    )
  }
  rendertechSuperintendentCard = () => {
    const { showSidePane, ClientUsersDetails } = this.props;
    // let superintendent = ClientUsersDetails && ClientUsersDetails.filter(r => r.role === "superintendent");
    const { TechSuperintendent } = this.state;
    return (
      <>
        {TechSuperintendent && TechSuperintendent.length ? TechSuperintendent.map(item => (
          <div className="card mb-2 click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.userName}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.telephone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-1 col-2 m-auto">
                    <div className="text-center">
                      <i className="fa fa-edit fa-lg fa-2x" onClick={() => this.EditUsers(2, item)}></i>
                      <i className="fa fa-trash m-1 fa-2x" onClick={() => this.DeleteUser(item)}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
          :
          <div className="card mb-2" style={{ overflow: "hidden", position: "relative" }}>
            <div class="container">
              <h6 className="resource-list-title no-item-card mb-0">
                No Users
              </h6>
            </div>
          </div>
        }
      </>
    )
  }
  rendertechExecutiveCard = () => {
    const { showSidePane, ClientUsersDetails } = this.props;
    const { TechExecutive } = this.state;
    return (
      <>
        {TechExecutive && TechExecutive.length ? TechExecutive.map(item => (
          <div className="card mb-2 click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-11 col-10 m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.userName}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 mb-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.telephone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-2 col-md-1 col-2 m-auto">
                    <div className="text-center">
                      <i className="fa fa-edit fa-lg fa-2x" onClick={() => this.EditUsers(3, item)}></i>
                      <i className="fa fa-trash m-1 fa-2x" onClick={() => this.DeleteUser(item)}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
          :
          <div className="card mb-2" style={{ overflow: "hidden", position: "relative" }}>
            <div class="container">
              <h6 className="resource-list-title no-item-card mb-0">
                No Users
              </h6>
            </div>
          </div>
        }
      </>
    )
  }

  moveClientList = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Client");
  };

  DeleteUser(item) {

    const { dispatch } = this.props;
    let clientuserArray = [];
    let clientuser = {
      clientUserId: item.clientUserId,
      clientId: item.clientId,
      userRole: item.userRole,
      userName: item.userName,
      email: item.email,
      telephone: item.telephone,
      isDeleted: true,
      modifiedBy: ""
    }

    clientuserArray.push(clientuser);

    let url = `${API.postClientuser}`;
    axios.put(url, clientuserArray, {
      headers: {
        key: currentUser.accessToken,
      }
    })
      .then((response) => {
        dispatch(getClientUserDetails(item.clientId));
        dispatch({
          type: "postClientUserDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "postClientUserDetailsFailure",
          error: "ERROR"
        })
      })
  }

  EditUsers(type, item) {
    const { match } = this.props;
    const { params } = match;
    const { id } = params;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: true });
    window.scrollTo(0, 0);
    if (type === 1) {
      this.props.dispatch({ type: "GetFleetManagerDetails", data: item });
      // this.props.dispatch({ type: "GetFleetManagerlist", data: this.state.FleetManager });
      this.props.history.push(`/Home/Management/ClientEdit/${id}/EditFleetManager`);
    } else if (type === 2) {
      this.props.dispatch({ type: "GetTechSuperintendentDetails", data: item });
      this.props.history.push(`/Home/Management/ClientEdit/${id}/EditTechSuperintendent`);
    } else {
      this.props.dispatch({ type: "GetTechExecutiveDetails", data: item });
      this.props.history.push(`/Home/Management/ClientEdit/${id}/EditTechExecutive`);
    }
  };

  showFleetManagersSidePane() {
    const { match } = this.props;
    const { params } = match;
    const { id } = params;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetFleetManagerDetails", data: null });
    this.props.history.push(`/Home/Management/ClientEdit/${id}/EditFleetManager`);
    window.scrollTo(0, 0);
  }

  showTechSuperintendentsSidePane() {
    const { match } = this.props;
    const { params } = match;
    const { id } = params;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetTechSuperintendentDetails", data: null });
    this.props.history.push(`/Home/Management/ClientEdit/${id}/EditTechSuperintendent`);
    window.scrollTo(0, 0);
  }

  showTechExecutiveSidePane() {
    const { match } = this.props;
    const { params } = match;
    const { id } = params;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetTechExecutiveDetails", data: null });
    this.props.history.push(`/Home/Management/ClientEdit/${id}/EditTechExecutive`);
    window.scrollTo(0, 0);
  }
}

function mapStateToProps(state) {
  return {
    fleetManagerList: state.MasterScreenReducer.fleetManagerlist,
    techSuperintendentList: state.MasterScreenReducer.TechSuperintendentlist,
    techExecutiveList: state.MasterScreenReducer.TechExecutivelist,
    ClientDetails: state.MasterScreenReducer.ClientDetails,
    ClientUsersDetails: state.MasterScreenReducer.ClientUsersDetails,
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientManagementEdit);
